import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import Pagination from "../../../utils/pagination";
import { fill_action } from "../../../actions/fillCombo_action";
import Workbook from "react-excel-workbook";
import moment from "moment";
import DatePicker from "react-datepicker";
import { AccountTypeActionId, countryActionId, exhibitionActionId, loginUrl, toastError, toastSuccess } from "../../../utils/constants";
import { getDelegateRegistrationList_action, delegatePreviewSubmit_action } from "../../../actions/delegate_module_action/delegate_registration_action/delegate_registration_action";

class DelegateRegistrationList extends Component {
    // intialize constructor
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            currentPage: 1,
            countryList: [],
            delegateList: [],
            exhibitionID: '',
            exhibitionList: [],
            personName: '',
            DelegateRegistrationNo: '',
            CompanyName: '',
            PrimaryEmail: '',
            CountryID: '',
            AccountTypeID: '',
            AccountTypeList: [],
            loginAccesslist: []
        };

        this.onCreateExcel = this.onCreateExcel.bind(this)
        this.updateItem = this.updateItem.bind(this);
    }

    updateItem(item) {
        const { delegateList } = this.state;
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = delegateList.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(delegateList.length / recordsPerPage);
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '49');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '49');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '49');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    getDownloadAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '49');
        if (moduleAccess) {
            return moduleAccess.DownloadAccess;
        } else {
            return false
        }
        return false;
    }

    getSendAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '49');
        if (moduleAccess) {
            return moduleAccess.SendAccess;
        } else {
            return false
        }
        return false;
    }


    getSpecialAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '49');
        if (moduleAccess) {
            return moduleAccess.Is_SpecialAccess;
        } else {
            return false
        }
        return false;
    }


    onCreateExcel() {
        const { delegateList } = this.state;
        console.log('ioioio')
        var list = [];
        delegateList.length > 0 &&
            delegateList.map((data) => {
                var obj = { ...data };
                list.push(obj);
            });
        list.length > 0 &&
            list.map((data) => {
                delete data.AccountID;
                delete data.AccountTypeID;
                delete data.CountryID;
                delete data.DelegateRegistrationID;
                delete data.ExhibitionID;
                delete data.PersonIncharge_GenderID;
            });
        var columnArray = [],
            rowData = [];
        // for column data
        list.map((data, index) => {
            if (index == 0) {
                Object.keys(data).map((key, index) => {
                    columnArray.push(key);
                });
            }
        });

        // for row data
        list.map((data, index) => {
            rowData.push(data);
        });

        // console.log("rowData", rowData)
        // this.setState({
        //     columnArrayData: columnArray,
        //     rowData: rowData
        // })

        // { this.renderList() }
        return (
            <div className="">
                {delegateList.length > 0 ? (
                    <Workbook filename="DelegateRegistration.xlsx" style={{}} element={
                        <button type="button"
                            className="btn btn-aqua mt-1 ms-2"
                            disabled={!this.getWriteAccess()}
                        >
                            Excel
                        </button>
                    }>
                        <Workbook.Sheet data={rowData} name="Sheet A">
                            {columnArray.map((value, index) =>
                                <Workbook.Column label={value} value={value} />
                            )
                            }
                        </Workbook.Sheet>
                    </Workbook>
                ) : (
                    <button type="button" className="btn btn-aqua" disabled={true}>
                        Excel
                    </button>
                )}
            </div>
        );
    }
    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        this.getFillList(countryActionId, "", "", "", "", "");
        this.getFillList(exhibitionActionId, "", "", "", "", "");
        this.getFillList(AccountTypeActionId, "", "", "", "", "");
        this.getDelegateRegistrationList();
    }

    getDelegateRegistrationList() {
        const { exhibitionID, personName, DelegateRegistrationNo, CompanyName, PrimaryEmail, CountryID, AccountTypeID } = this.state
        this.setState({ isLoading: true });
        this.props
            .getDelegateRegistrationList_action(exhibitionID, DelegateRegistrationNo, CompanyName, personName, PrimaryEmail, CountryID, AccountTypeID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ delegateList: data.data, isLoading: false });
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    resendUserCred(AccountTypeID, AccountID, DelegateRegistrationID, status, UUID) {
        this.setState({ isLoading: true });
        this.props
            .delegatePreviewSubmit_action(AccountTypeID, AccountID, DelegateRegistrationID, 0, 0, status, UUID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("User Credential Send Successfully");
                    this.setState({ isLoading: false });
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // get fill List dropdown
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        this.setState({ isLoading: true });
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
            .then((data) => {
                if (data.error != 1) {
                    // country List
                    if (actionID === countryActionId) {
                        this.setState({
                            countryList: data.data,
                        });
                    }
                    if (actionID === exhibitionActionId) {
                        this.setState({
                            exhibitionList: data.data,
                        });
                    }
                    if (actionID === AccountTypeActionId) {
                        this.setState({
                            AccountTypeList: data.data,
                        });
                    }
                    this.setState({ isLoading: false });
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    clearValue() {
        this.setState({
            exhibitionID: '',
            personName: '',
            DelegateRegistrationNo: '',
            CompanyName: '',
            PrimaryEmail: '',
            CountryID: '',
            AccountTypeID: '',
        }, () => {
            this.getDelegateRegistrationList()
        })
    }

    onLogin(data) {
        var exhId = data.ExhibitionID;
        var id = data.UserName;
        var loginContent = `${exhId}--${id}`;
        var url = `${loginUrl}${loginContent}`;
        window.open(url, "_blank");
    }

    updateDelegate(Userid, AccountID, DelegateRegistrationID) {
        this.props.navigate("/delegateForm", {
            state: {
                UserId: Userid,
                AccountID: AccountID,
                selectedVisitorID: AccountID,
                update: true,
                DelegateRegistrationID: DelegateRegistrationID,
            },
        });
    }

    render() {
        const { isLoading, currentPage, delegateList, exhibitionList, personName, DelegateRegistrationNo, CompanyName, PrimaryEmail, CountryID, AccountTypeID, AccountTypeList } = this.state;
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = delegateList.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(delegateList.length / recordsPerPage);
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <ToastContainer />
                <HeaderWithLogo />
                <div className="row m-0">
                    <div className="breadcrumb-scroll-fixed with-dr-container">
                        <h6 className="mb-0 px-2 py-2 text-white">Delegate List</h6>
                    </div>
                </div>
                <div
                    className={"with-dr-container com-height"}
                >
                    <div className="main-container admin-top-space">
                        <AdminDrawer />
                    </div>
                    <div className="main-container p-2 mt-1">
                        <div className="row m-0">
                            <div className="col-xl-3 mb-3">
                                <label htmlFor="validationCustom03">Exhibition</label>
                                <select
                                    className="form-control"
                                    value={this.state.exhibitionID}
                                    onChange={(e) =>
                                        this.setState({ exhibitionID: e.target.value })
                                    }
                                >
                                    <option value={""}>Select</option>
                                    {this.state.exhibitionList.length > 0 &&
                                        this.state.exhibitionList.map((data) => (
                                            <option
                                                key={data.ExhibitionID}
                                                value={data.ExhibitionID}
                                            >
                                                {data.ExhibitionName}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="col-xl-3 mb-3">
                                <label htmlFor="validationCustom03">Account Type</label>
                                <select
                                    className="form-control"
                                    value={this.state.AccountTypeID}
                                    onChange={(e) =>
                                        this.setState({ AccountTypeID: e.target.value })
                                    }
                                >
                                    <option value={""}>Select</option>
                                    {this.state.AccountTypeList.length > 0 &&
                                        this.state.AccountTypeList.map((data) => (
                                            <option
                                                key={data.AccountTypeID}
                                                value={data.AccountTypeID}
                                            >
                                                {data.Name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="col-xl-3 mb-3">
                                <label>Registration No.</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    defaultValue=""
                                    required=""
                                    value={DelegateRegistrationNo}
                                    onChange={(e) =>
                                        this.setState({ DelegateRegistrationNo: e.target.value })
                                    }
                                />
                            </div>
                            <div className="col-xl-3 mb-3">
                                <label>Company Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    defaultValue=""
                                    required=""
                                    value={CompanyName}
                                    onChange={(e) =>
                                        this.setState({ CompanyName: e.target.value })
                                    }
                                />
                            </div>
                            <div className="col-xl-3 mb-3">
                                <label>Person Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    defaultValue=""
                                    required=""
                                    value={personName}
                                    onChange={(e) =>
                                        this.setState({ personName: e.target.value })
                                    }
                                />
                            </div>
                            <div className="col-xl-3 mb-3">
                                <label>Primary Email</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    defaultValue=""
                                    required=""
                                    value={PrimaryEmail}
                                    onChange={(e) =>
                                        this.setState({ PrimaryEmail: e.target.value })
                                    }
                                />
                            </div>
                            <div className="col-xl-3 mb-3">
                                <label htmlFor="validationCustom03">Country</label>
                                <select
                                    className="form-control"
                                    value={CountryID}
                                    onChange={(e) =>
                                        this.setState({ CountryID: e.target.value })
                                    }
                                >
                                    <option value={""}>Select</option>
                                    {this.state.countryList.length > 0 &&
                                        this.state.countryList.map((data) => (
                                            <option
                                                key={data.Code}
                                                value={data.Code}
                                            >
                                                {data.Description}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="col-xl-3 mt-4" style={{ display: 'flex' }}>
                                <div >
                                    <button
                                        type="button"
                                        className="btn btn-aqua mt-1"
                                        onClick={(e) => this.getDelegateRegistrationList()}
                                    >
                                        Search
                                    </button>
                                </div>
                                <div >
                                    <button
                                        type="button"
                                        className="btn btn-gray mt-1 ms-2"
                                        onClick={(e) => this.clearValue()}
                                    >
                                        Clear
                                    </button>
                                </div>
                                {this.onCreateExcel()}
                            </div>
                        </div>
                        <div className="row m-2 table-responsive">
                            <table class="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th>Registration No.</th>
                                        <th>Account Type</th>
                                        <th>Company Name</th>
                                        <th>Person Name</th>
                                        <th>Email</th>
                                        <th>Mobile</th>
                                        <th>Country</th>
                                        {this.getUpdateAccess() && <th>Action</th>}
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentRecords.length > 0 && currentRecords != null ? (
                                        currentRecords.map((data, i) => (
                                            <tr>
                                                <td>
                                                    {data.DelegateRegistrationNo != null ? data.DelegateRegistrationNo : "-"}
                                                </td>
                                                <td>
                                                    {data.AccountTypeName != null ? data.AccountTypeName : "-"}
                                                </td>
                                                <td>
                                                    {data.CompanyName != null ? data.CompanyName : "-"}
                                                </td>
                                                <td>{data.personName != null ? data.personName : "-"}</td>
                                                <td>
                                                    {data.PrimaryEmail != null ? data.PrimaryEmail : "-"}
                                                </td>
                                                <td>
                                                    {data.MobileNo &&
                                                        data.MobileNo.split("-")[1]?.trim() !== ""
                                                        ? data.MobileNo
                                                        : "-"}
                                                </td>
                                                <td>{data.Country != null ? data.Country : "-"}</td>
                                                {this.getUpdateAccess() && <td className="text-center">
                                                    <i
                                                        className="fa fa-pencil grid-icon"
                                                        aria-hidden="true"
                                                        title="Update vendor"
                                                        style={{ marginRight: "12px", cursor: "pointer" }}
                                                        onClick={() =>
                                                            this.updateDelegate(data.Userid, data.AccountID, data.DelegateRegistrationID)
                                                        }
                                                    />
                                                </td>}
                                                <td className="text-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-blue-border py-1 ms-2"
                                                        disabled={!this.getSendAccess()}
                                                        onClick={(e) =>
                                                            this.resendUserCred(data.AccountTypeID, data.AccountID, data.DelegateRegistrationID, data.StatusID, data.UUID)
                                                        }
                                                    >
                                                        Send UserID & Password
                                                    </button>
                                                    <button
                                                        type="button"
                                                        disabled={!this.getSpecialAccess()}
                                                        className="btn btn-aqua ms-2"
                                                        onClick={(e) => this.onLogin(data)}
                                                    >
                                                        Login
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={10} className="text-center">
                                                Record not found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <div className="mt-2 d-flex justify-content-between align-items-center">
                                {delegateList.length > 0 ? (
                                    <Pagination
                                        nPages={nPages}
                                        currentPage={currentPage}
                                        setCurrentPage={this.updateItem}
                                    />
                                ) : (
                                    <div></div>
                                )}
                                <div className="tab-rec pe-2">
                                    <p>{`${currentPage} of ${nPages} pages`}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <Footerwithdr /> */}
            </>
        );
    }
}
export default withRouter(
    connect(null, {
        fill_action, getDelegateRegistrationList_action, delegatePreviewSubmit_action
    })(DelegateRegistrationList)
);
